import React from "react";
import PeriodicElement from "./PeriodicElement";
import { FlexContainer } from "./styled";

const PeriodicTableElements = props => (
  <FlexContainer>
    {props.elements.map(element => (
      <PeriodicElement
        name={element.name}
        weight={element.weight}
        number={element.number}
        symbol={element.symbol}
      />
    ))}
  </FlexContainer>
);

export default PeriodicTableElements;



// WEBPACK FOOTER //
// ./src/pages/Materials/MaterialComponent/PeriodicTableElements.js